<template>
    <div class="review-wrapper"><img class="mw-100 rounded mb-4" :src="image" v-if="image"/>
        <div class="text-center mb-4">{{ text }}</div>
        <div class="d-flex justify-content-center d-flex flex-column">
            <button-loading class="btn swell-btn btn-primary mb-1" @click="recommend(true)" :loading="form.submitting">
                {{ yes }}
            </button-loading>
            <button class="btn swell-btn btn-link mb-1" @click="recommend(false)">{{ no }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            image: {default: null},
            text: {default: 'Would you recommend this Company to others?'},
            yes: {default: 'Yes'},
            no: {default: 'No'},
            form: {default: () => new Form({recommended: null})}
        },

        methods: {
            recommend(wouldRecommend) {
                this.form.recommended = wouldRecommend;
                this.$emit('recommend', wouldRecommend);
            }
        }
    };
</script>
